import { Category } from "../Model/Category";
import { CategoryRepository } from "../Repository/CategoryRepository";

export interface CreateCategoryUseCase {
  invoke: (data: Category) => Promise<Category[]>;
}

export class CreateCategory implements CreateCategoryUseCase {

  private categoryRepo: CategoryRepository;

  constructor(_CategoryRepo: CategoryRepository) {
    this.categoryRepo = _CategoryRepo;
  }

  async invoke(data: Category){

    if(!data){
        throw new Error(
            "Your todo should have at leat 2 characters."
          );
    }
     
    const created  = await this.categoryRepo.createCategory(data);
    return created;
  }
}